import { useAutocompleteSource } from '@eas/common-web';
import { DictPhysicalStorageAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function usePhysicalStorages() {
  return useAutocompleteSource<DictPhysicalStorageAutocomplete>({
    url: EvidenceApiUrl.DICT_PHYSICAL_STORAGE + '/autocomplete',
  });
}
